'use client'

import { usePreviewNavigation } from '@/hooks/usePreviewNavigation'
import { createContext, ReactNode, useContext } from 'react'

interface PreviewNavigationContextType {
  isInPreviewMode: boolean
  currentPreviewMode: string | null | undefined
  currentPreviewToken: string | null | undefined
  pushWithPreview: (href: string, options?: { scroll?: boolean }) => void
  replaceWithPreview: (href: string, options?: { scroll?: boolean }) => void
  createPreviewUrl: (
    pathname: string,
    additionalParams?: Record<string, string | undefined>
  ) => string
  createPreviewQueryString: (
    additionalParams?: Record<string, string | undefined>
  ) => string
}

const PreviewNavigationContext =
  createContext<PreviewNavigationContextType | null>(null)

interface PreviewNavigationProviderProps {
  children: ReactNode
}

export const PreviewNavigationProvider = ({
  children,
}: PreviewNavigationProviderProps) => {
  const previewNavigation = usePreviewNavigation()

  return (
    <PreviewNavigationContext.Provider value={previewNavigation}>
      {children}
    </PreviewNavigationContext.Provider>
  )
}

export const usePreviewNavigationContext = () => {
  const context = useContext(PreviewNavigationContext)
  if (!context) {
    throw new Error(
      'usePreviewNavigationContext must be used within a PreviewNavigationProvider'
    )
  }
  return context
}
